let cryptoProScript = document.createElement("script");
cryptoProScript.setAttribute("src", "https://www.cryptopro.ru/sites/default/files/products/cades/cadesplugin_api.js");
document.head.appendChild(cryptoProScript);
let fileref = document.createElement("script");
fileref.setAttribute("type", "text/javascript");
fileref.setAttribute("src", "/js/document-sign.js");
document.head.appendChild(fileref);
